"use memo"

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { CampaignDetailModel } from '@urbanx/agx.campaigns.client'
import TaskModalDialog from './TaskModalDialog'
import { useAgreementComplianceModal } from './useAgreementComplianceModal'

interface AgreementComplianceModalProps {
  campaignId: string
  campaign: CampaignDetailModel
  isOpen: boolean
  onClose: () => void
  tasks: AutopilotTaskDto[]
}

const AgreementComplianceModal = ({
  campaignId,
  campaign,
  isOpen,
  onClose,
  tasks,
}: AgreementComplianceModalProps) => {
  const { contentConfig } = useAgreementComplianceModal({
    campaignId,
    campaign,
    isOpen,
    tasks,
  })

  return (
    <TaskModalDialog
      title={'Agreement Compliance'}
      tasks={tasks}
      open={isOpen}
      onClose={onClose}
      campaignId={campaignId}
      campaign={campaign}
      contentConfig={contentConfig}
    />
  )
}

export default AgreementComplianceModal
